module.exports = __webpack_public_path__ + "static/hero-guarantee-large-4e7510fb9eed2e7c8e0730b606aae3ed.jpg";